import loadHeroImage from "shared/lib/load_hero_image"
import truncate from "lodash/truncate"
import classnames from "classnames"

import "./related_content.scss"

interface RelatedContentProps {
  relatedContent: {
    type: "story" | "consumer_solution"
    slug: string
    title: string
    hero_image: {
      background_image_url_1x: string | null
      background_color: string | null
      solution_image: string | null
    }
    description: string | null
    url: string
  }[]
  onStoryPage?: boolean
}

const trackClick = (type: string, slug: string) => {
  window.App.Utils?.logCustomDatadogAction?.("related_content_clicked", { type, slug })
}

const RelatedContent = ({ relatedContent, onStoryPage }: RelatedContentProps) =>
  relatedContent.length > 0 && (
    <>
      <h3 styleName="heading">You may also like</h3>
      <section styleName={classnames("related-content", { story: onStoryPage })}>
        {(relatedContent || []).map(content => {
          return (
            <a
              key={content.slug}
              href={content.url}
              rel="noreferrer"
              styleName="story-card"
              onClick={() => trackClick(content.type, content.slug)}
            >
              <div
                styleName="hero"
                title={content.title}
                aria-label={content.title}
                style={
                  content.hero_image.background_color
                    ? {
                        backgroundColor: content.hero_image.background_color,
                      }
                    : {}
                }
              >
                <img
                  src={loadHeroImage(content.hero_image, "square")}
                  title={content.title}
                  alt={content.title}
                  loading="lazy"
                />
              </div>
              <div styleName="title">
                <h5>{content.title}</h5>
              </div>

              <p styleName="description">
                {truncate(content.description, {
                  length: 240,
                  separator: /[ ,]/,
                })}
              </p>
            </a>
          )
        })}
      </section>
    </>
  )

export default RelatedContent
